import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { navLinks, routes, tabKeys } from '../../../constants';
import logo from '../../../images/logo_rev.svg';
import { fullName, isBusinessAdmin, isPublisher, isSystemOrSuperAdmin, isTeamManager } from '../../../services';
import { businessSelector } from '../../../state/modules/business';
import { sessionActions } from '../../../state/modules/session';
import { taskCountSelector } from '../../../state/modules/task/selectors';
import { currentUserSelector } from '../../../state/modules/user';
import { Icon } from '../../components';
import MenuItem from './mobile-nav-menu-item';

const NavMobile = ({
  isBusinessAdmin,
  isPublisher,
  isSystemAdmin,
  isManager,
  logout,
  menuOpen,
  toggleMenu,
  closeMenu,
  userFullName,
  goTo,
  ...props
}) => (
    <div className={classNames({ 'hamburgler-active': menuOpen })}>
      <nav id='navigation--mobile'>
        <ul>
          {
            fp.flow(
              fp.filter((l) => !l.shouldDisplay || l.shouldDisplay()),
              fp.map(({ icon, title, route, notification }) =>
                <MenuItem key={title} label={title} route={route} icon={icon} notification={notification} />
              )
            )(navLinks(props))
          }
          <MenuItem label='Menu' icon='hamburger' onClick={toggleMenu} upperBadge />
        </ul>
      </nav>
      <div className='hamburgler-menu'>
        <header>
          <div className='logo'>
            <img src={logo} alt='Caddie' />
          </div>
          <div className='hamburgler-close' onClick={closeMenu}>
            <Icon icon='close' />
          </div>
        </header>
        <div className='hamburgler-menu-list'>
          <div className='loggedInAs'>Logged in as {userFullName}</div>
          <ul>
            {
              isPublisher ?
                <MenuItem
                  label='Go to Publisher Portal'
                  icon='dashboard-large'
                  route={routes.publisherPortal.dashboard} /> :
                null
            }
            {
              isSystemAdmin ?
                <MenuItem
                  label='Go to Admin Portal'
                  icon='dashboard-large'
                  route={routes.adminPortal.dashboard}
                /> : null
            }
            <MenuItem label='Account Settings' icon='settings' onClick={() => {
              goTo(routes.app.accountSettings())
              closeMenu()
            }} />
            {
              (isBusinessAdmin || isManager) ?
                <MenuItem label={`Users & Teams`} icon='user' onClick={() => {
                  goTo(routes.app.usersAndTeamsSettings(isBusinessAdmin ? tabKeys.usersAndTeamsSettings.userManagement : tabKeys.usersAndTeamsSettings.teams))
                  closeMenu()
                }} /> :
                null
            }
            {
              <MenuItem label='Professional Profile' icon='professional-profile-large' onClick={() => {
                goTo(routes.app.professionalProfile.root)
                closeMenu()
              }} />
            }
            {
              <MenuItem label='Training Plans' icon='settings' onClick={() => {
                goTo(routes.app.trainingPlansSettings())
                closeMenu()
              }} />
            }
            <MenuItem
              label='Support'
              icon='help-large'
              route={`mailto:support@thinkcaddie.com?subject=Caddie Support Request&cc=helpdesk@complii.com.au`}
              externalLink />
            <MenuItem label='Log out' icon='logout' onClick={(e) => logout()} />
          </ul>
        </div>
      </div>
    </div>
  );

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  business: businessSelector(state),
  taskCount: taskCountSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
  logout: bindActionCreators(sessionActions.session.logout, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers({
    menuOpen: false
  }, {
      toggleMenu: ({ menuOpen }) => () => ({
        menuOpen: !menuOpen
      }),
      closeMenu: () => () => ({
        menuOpen: false
      })
    }),
  withProps(({
    user,
    business
  }) => ({
    isBusinessAdmin: isBusinessAdmin(user),
    isSystemAdmin: isSystemOrSuperAdmin(user),
    isPublisher: fp.overSome([isPublisher, isSystemOrSuperAdmin])(user),
    userFullName: fullName(user),
    isManager: isTeamManager(user, business)
  }))
)(NavMobile);



// WEBPACK FOOTER //
// ./src/containers/partials/nav/nav-mobile.js